import { useLocalObservable } from '@euler/utils/hooks/useLocalObservable';
import { memo } from 'react';
import { BehaviorSubject, scan } from 'rxjs';
import { kVoiceBars, meterLevel } from '../functions/meterLevel';
import { LevelBars } from './LevelBars';

const kSilent: readonly number[] = Array(kVoiceBars).fill(0);

/** A voice as it is heard: the latest levels, newest right. */
export const LevelMeter = memo(
  ({ level$, color }: { level$: BehaviorSubject<number>; color: string }) => {
    const levels = useLocalObservable(
      () =>
        level$.pipe(
          scan(
            (history: readonly number[], level) => [
              ...history.slice(1),
              meterLevel(level),
            ],
            kSilent,
          ),
        ),
      kSilent,
      [level$],
    );
    return <LevelBars levels={levels} color={color} />;
  },
);
